<template>
  <v-card flat class="mx-auto">
    <v-card-title>
      {{ product.title }}
    </v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-row>
          <v-col cols="5" lg="2" md="4" align-self="center">
            <h3>Quantity</h3>
          </v-col>
          <v-col cols="6" lg="3">
            <v-text-field dense v-model="quantity" type="number" outlined>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="5" lg="2" md="4" align-self="center">
            <h3>Shaft Material</h3>
          </v-col>
          <v-col cols="6" lg="3">
            <v-select
              v-model="material"
              :items="['Steel', 'Graphite']"
              outlined
              dense
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="5" lg="2" md="4" align-self="center">
            <h3>Dexterity</h3>
          </v-col>
          <v-col cols="6">
            <v-radio-group v-model="dexterity" row dense>
              <v-radio label="Right Hand" value="RH"></v-radio>
              <v-radio label="Left Hand" value="LH"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="5" lg="2" md="4" align-self="center">
            <h3>Flex</h3>
          </v-col>
          <v-col cols="6" lg="9">
            <v-radio-group v-model="flex" row dense>
              <v-radio label="X-Stiff" value="x-stiff"></v-radio>
              <v-radio label="Stiff" value="stiff"></v-radio>
              <v-radio label="Regular" value="reg flex"></v-radio>
              <v-radio label="Senior/Medium" value="med flex"></v-radio>
              <v-radio label="Ladies" value="ladies"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" lg="2" md="3" align-self="center">
            <h3>Condition</h3>
          </v-col>
          <v-col cols="7">
            <v-slider
              v-model="condition"
              step="1"
              min="1"
              max="10"
              thumb-label="always"
              ticks
              dense
            ></v-slider>
          </v-col>
        </v-row>
        <v-row v-if="isIronSet">
          <v-col cols="4" lg="2" md="3" align-self="center">
            <h3>Irons</h3>
          </v-col>
        </v-row>
        <v-row v-if="isIronSet" dense align="center" justify="space-around">
          <v-col cols="0" lg="1" md="1" sm="0"> </v-col>
          <v-col v-for="preset in presets" :key="preset.title">
            <v-btn
              class="ma-2"
              outlined
              :color="preset.color"
              @click="selection = preset.clubs"
            >
              {{ preset.title }}
            </v-btn>
          </v-col>
          <v-col cols="0" lg="2" md="1" sm="0"> </v-col>
        </v-row>
        <v-row v-if="isIronSet" dense align="center" justify="space-around">
          <v-col cols="0" lg="1" md="1" sm="0"> </v-col>
          <v-col cols="1" v-for="title in titlesA" :key="title">
            <v-checkbox
              v-model="selection"
              :value="title"
              @change="sortSelection"
            >
              <template v-slot:prepend>
                <div
                  class="v-label theme--light"
                  style="right: 0px; left: auto; position: relative;"
                >
                  {{ title }}
                </div>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="0" lg="2" md="1" sm="0"> </v-col>
        </v-row>
        <v-row v-if="isIronSet" dense align="center" justify="space-around">
          <v-col cols="0" lg="2" md="1" sm="0"> </v-col>
          <v-col v-for="title in titlesB" :key="title">
            <v-checkbox
              v-model="selection"
              :value="title"
              @change="sortSelection"
            >
              <template v-slot:prepend>
                <div
                  class="v-label theme--light"
                  style="right: 0px; left: auto; position: relative;"
                >
                  {{ title }}
                </div>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="0" lg="5" md="3" sm="0"> </v-col>
        </v-row>
        <v-row v-if="isIronSet" align="center" justify="space-around">
          <div v-if="isIronSet">
            {{ ironsText }}
            <v-btn
              class="ma-2"
              outlined
              small
              color="red"
              @click="selection = []"
            >
              Clear
            </v-btn>
          </div>
        </v-row>
        <v-row align="center" justify="space-around">
          <v-col cols="0" lg="3" md="3" sm="0"> </v-col>
          <v-col>
            <v-btn @click="commitDetails" color="success">
              {{(submitText ? submitText : "Add to Quote")}}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn @click="$emit('close')" color="gray">
              {{(cancelText ? cancelText : "Discard Club")}}
            </v-btn>
          </v-col>
          <v-col cols="0" lg="3" md="3" sm="0"> </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions> </v-card-actions>
  </v-card>
</template>

<script>
import { storage } from "@/firebase";

export default {
  name: "ProductDetails",
  props: {
    product: Object,
    submitText: String,
    cancelText: String,
  },
  data() {
    return {
      defaultPricing: false,
      selection: [],
      quantity: 1,
      material: "Steel",
      dexterity: null,
      condition: 7,
      flex: null,
      image: require("@/assets/golf-club.png"),

      titlesA: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
      titlesB: ["PW", "GW", "SW", "LW"],
      presets: [
        {
          title: "3-PW",
          clubs: ["3", "4", "5", "6", "7", "8", "9", "PW"],
          color: "green",
        },
        {
          title: "4-PW",
          clubs: ["4", "5", "6", "7", "8", "9", "PW"],
          color: "green",
        },
        {
          title: "4-GW",
          clubs: ["4", "5", "6", "7", "8", "9", "PW", "GW"],
          color: "green",
        },
        {
          title: "5-GW",
          clubs: ["5", "6", "7", "8", "9", "PW", "GW"],
          color: "green",
        },
      ],
    };
  },
  created() {
    this.selection = this.presets[1].clubs;

    const graphite_default = ["driver", "hybrid", "fairway-wood"];
    if (graphite_default.includes(this.product.type)) {
      this.material = "Graphite";
    }

    const not_a_price = [0, "", NaN, null, undefined];
    if (not_a_price.includes(this.product.price)) {
      this.product.price = this.$store.getters.getConfig["Default Price"][
        this.product.type
      ];
      this.defaultPricing = true;
      // Possibility of default price returning error:
      if (not_a_price.includes(this.product.price)) {
        console.log("Error fetching default price list");
        if (this.product.type === "iron-set") {
          this.product.price = 35;
        } else {
          this.product.price = 5;
        }
      }
    }
    if (this.product.image !== "") {
      if (this.product.image.startsWith("http")) {
        this.image = this.product.image;
      } else {
        storage
          .ref("images/" + this.product.image)
          .getDownloadURL()
          .then((res) => (this.image = res))
          .catch((err) => {
            console.error(err);
          });
      }
    }
  },
  methods: {
    commitDetails() {
      // Default pricing should not use multiplier
      // const price_multiplier = this.defaultPricing
      //   ? 1.0
      //   : this.$store.getters.getConfig["Trade-In Price Multiplier"];
      // const price_rounded = this.unit_price * price_multiplier;
      const details = {
        ...this.product,
        quantity: this.quantity,
        material: this.material,
        flex: this.flex,
        dexterity: this.dexterity,
        condition: this.condition,
        unit_price: this.unit_price,
        subtotal: this.unit_price * this.quantity,
        iron_selection: this.isIronSet ? this.selection : null,
        description: this.descriptionText,
        image: this.image,
      };
      this.$emit("submit", details);
    },
    sortSelection() {
      // Build sort list
      let vals = {};
      const irons = this.titlesA.concat(this.titlesB);
      let i = 0;
      irons.forEach((iron) => {
        vals[iron] = i;
        i++;
      });
      this.selection.sort((a, b) => {
        return vals[a] - vals[b];
      });
    },
  },
  computed: {
    isIronSet() {
      return this.product.type === "iron-set";
    },
    missingIrons() {
      const irons = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "PW"];
      const additional_wedges = ["GW", "SW", "LW"];

      const low = irons.indexOf(this.selection[0]);
      const trim_selection = this.selection.filter((iron) =>
        irons.includes(iron)
      );
      const high = irons.indexOf(trim_selection[trim_selection.length - 1]);

      const missing = irons.filter((iron, i) => {
        if (i <= low || i >= high) {
          return false;
        }
        if (!this.selection.includes(iron)) {
          return true;
        }
      });

      const additional = additional_wedges.filter((iron) => {
        if (this.selection.includes(iron)) {
          return true;
        } else return false;
      });

      return {
        low: irons[low],
        high: irons[high],
        missing: missing,
        additional: additional,
      };
    },
    unit_price() {
      if (this.isIronSet) {
        const continuousClubValue = this.product.price / 7;
        let singleClubValue = parseFloat(
          this.$store.getters.getConfig["Default Price"]["unmatched-iron"]
        );
        if (singleClubValue === undefined) {
          console.log("Error fetching unmatched iron default price");
          singleClubValue = 5;
        }
        const minimumSet = ["6", "7", "8", "9", "PW"];
        const additionalContinuousClubs = ["5", "4", "3", "2", "1"];
        const additionalWedges = ["GW", "SW", "LW"];

        const missingMin = minimumSet.filter((iron) => {
          if (!this.selection.includes(iron)) {
            return true;
          }
        });
        if (missingMin.length > 0) {
          // Don't have minimum set
          return singleClubValue * this.selection.length;
        } else {
          // Have minimum set, find longest continuous chain
          let subtotal = minimumSet.length * continuousClubValue;
          let continuous = true;
          // additional wedges are all considered continuous
          additionalWedges.forEach((wedge) => {
            if (this.selection.includes(wedge)) {
              subtotal += continuousClubValue;
            }
          });
          // add rest of club values depending on if continuous or not
          additionalContinuousClubs.forEach((club) => {
            if (this.selection.includes(club)) {
              subtotal += continuous ? continuousClubValue : singleClubValue;
            } else {
              // missing club, break the continuity and don't add value to subtotal
              continuous = false;
            }
          });
          return subtotal;
        }
      } else {
        return this.product.price;
      }
    },
    ironsText() {
      let desc = this.missingIrons.low + "-" + this.missingIrons.high;
      if (
        this.missingIrons.low === undefined ||
        this.missingIrons.high === undefined
      ) {
        desc = "";
      }
      const n_additional = this.missingIrons.additional.length;
      const sep = desc === "" ? "" : ", ";
      if (n_additional > 0) {
        desc += sep + this.missingIrons.additional.join(", ");
      }
      const n_missing = this.missingIrons.missing.length;
      if (n_missing > 0) {
        desc +=
          ", missing " +
          this.missingIrons.missing.join(", ") +
          " iron" +
          (n_missing > 1 ? "s" : "");
      }
      return desc;
    },
    descriptionText() {
      const flex = this.flex !== null ? ` ${this.flex},` : "";
      const dex = this.dexterity !== null ? ` ${this.dexterity},` : "";
      let desc = `${this.material},${dex}${flex} ${this.condition}/10`;
      if (this.isIronSet) {
        desc += ", " + this.ironsText;
      }
      return desc;
    },
  },
};
</script>

<style scoped></style>
